import React from "react";
import PlanosCard from "./planos.jsx";
import "./planos-Style.css";

//Privativos
import Planos01 from "../../img/SalaPrivativa01.jpg";
import Planos02 from "../../img/SalaPrivativa02.png";
import Planos03 from "../../img/SalaPrivativa03.jpg";
//Estações
import Planos04 from "../../img/Estacao01.png";
import Planos05 from "../../img/Estacao02.png";
//Reuniões
import Planos06 from "../../img/Reuniao01.jpeg";
import Planos07 from "../../img/Reuniao02.jpg";
import Planos08 from "../../img/Reuniao03.jpeg";
import Planos09 from "../../img/Reuniao04.jpg";
//Eventos
import Planos10 from "../../img/Auditorio01.png";
import Planos11 from "../../img/Auditorio02.jpg";
import Planos12 from "../../img/Auditorio03.jpg";
import Planos13 from "../../img/Auditorio04.jpg"; 
import Planos14 from "../../img/Auditorio05.jpg";
//Endereço Fiscal
import Planos15 from "../../img/EndComercial.png";
//Endereço Comercial
import Planos16 from "../../img/EndFiscal.jpg";



const CardsList = () => {
  const products = [
    {
      title: "Sala Privativa",
      subtitle: " A partir de: R$1300,00/mês",
      description:
        "Ambiente privativo com todos os benefícios de um escritório completo em espaço compartilhado. Opções: 2, 4 ou 6 usuários",
      images: [
        Planos01,
        Planos02,
        Planos03
      ],
      buttonLabel: "Saiba mais",
    },

    {
      title: "Sala de Reunião",
      subtitle: " A partir de: R$50,00/hora",
      description:
        "Ambiente inspirador para encontros, apresentações e negociações. Capacidade: 6 a 10 pessoas.",
      images: [
        Planos06,
        Planos07,
        Planos08,
        Planos09,
      ],
      buttonLabel: "Saiba mais",
    },
    
    {
      title: "Estação de Trabalho",
      subtitle: " A partir de: R$90,00/dia",
      description:
        "Espaço individual em escritório compartilhado com estrutura completa e endereço comercial de prestígio.",
      images: [
        Planos04,
        Planos05,
      ],
      buttonLabel: "Saiba mais",
    },
    {
      title: "Endereço comercial",
      subtitle: " A partir de: R$100,00/ mês",
      description:
        "Endereço profissional para registrar sua empresa e receber correspondências com total praticidade.",
      images: [
        Planos15,
      ],
      buttonLabel: "Saiba mais",
    },
     {
      title: "Salão de eventos",
      subtitle: " A partir de: R$1500,00",
      description:
        "Espaço amplo e moderno para palestras, workshops e reuniões, com estrutura completa e confortável.",
      images: [
        Planos10,
        Planos11,
        Planos12,
        Planos13,
        Planos14,
      ],
      buttonLabel: "Saiba mais",
    },
    
    {
      title: "Endereço fiscal",
      subtitle: " A partir de: R$200,00/mês",
      description:
        "Formalize seu CNPJ com um endereço fiscal estratégico, sem precisar manter um local fixo.",
      images: [
        Planos16,
        
      ],
      buttonLabel: "Saiba mais",
    },

  ];

  return (
    <ul className="cards">
      {products.map((p, i) => (
        <li className="cards__item" key={i}>
          <PlanosCard {...p} />
        </li>
      ))}
    </ul>
  );
};

export default CardsList;
